import { render } from "./FooterDesc.vue?vue&type=template&id=49d0a542&scoped=true"
import script from "./FooterDesc.vue?vue&type=script&lang=js"
export * from "./FooterDesc.vue?vue&type=script&lang=js"

import "./FooterDesc.vue?vue&type=style&index=0&id=49d0a542&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d0a542"]])

export default __exports__